import { denormalize } from "normalizr";
import { user } from "../../../api/schema";

export default id => state => {
  try {
    const denormalized = denormalize(
      { item: id },
      { item: user },
      state.entities
    );

    return denormalized.item || {};
  } catch (err) {
    return {};
  }
};
